export const INTEGRATION_ARTIFACT_CODE = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Integration Discovery Dashboard</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        
        body {
            font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
            background: #ffffff;
            color: #37352f;
            line-height: 1.5;
            display: flex;
            height: 100vh;
            overflow: hidden;
        }
        
        .sidebar {
            width: 260px;
            background: #f7f6f3;
            border-right: 1px solid #e9e7e3;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            flex-shrink: 0;
        }
        
        .sidebar-header {
            padding: 1rem 0.875rem;
            border-bottom: 1px solid #e9e7e3;
        }
        
        .workspace-name {
            font-size: 0.875rem;
            font-weight: 600;
            color: #37352f;
            padding: 0.375rem 0.5rem;
            border-radius: 3px;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
        
        .sidebar-section {
            padding: 0.5rem 0;
        }
        
        .section-title {
            font-size: 0.6875rem;
            font-weight: 600;
            color: #9b9a97;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            padding: 0.5rem 0.875rem;
            margin-top: 0.5rem;
        }
        
        .nav-item {
            padding: 0.375rem 0.875rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-size: 0.875rem;
            color: #37352f;
            border-radius: 3px;
            margin: 0.125rem 0.5rem;
            transition: background 0.1s;
        }
        
        .nav-item:hover {
            background: rgba(0,0,0,0.03);
        }
        
        .nav-item.active {
            background: rgba(0,0,0,0.05);
            font-weight: 500;
        }
        
        .nav-icon {
            width: 1.25rem;
            height: 1.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .main-content {
            flex: 1;
            overflow-y: auto;
            background: #ffffff;
        }
        
        .page-header {
            padding: 3rem 4rem 2rem 4rem;
            border-bottom: 1px solid #e9e7e3;
        }
        
        .page-icon {
            font-size: 4.875rem;
            line-height: 1;
            margin-bottom: 0.5rem;
        }
        
        .page-title {
            font-size: 2.5rem;
            font-weight: 700;
            color: #37352f;
            margin-bottom: 0.5rem;
        }
        
        .page-subtitle {
            font-size: 0.875rem;
            color: #787774;
            line-height: 1.6;
        }
        
        .content-wrapper {
            padding: 2rem 4rem 4rem 4rem;
            max-width: 1200px;
        }
        
        .content-section {
            display: none;
        }
        
        .content-section.active {
            display: block;
        }
        
        .callout {
            display: flex;
            gap: 0.75rem;
            padding: 1rem;
            margin: 1rem 0;
            background: #f7f6f3;
            border-radius: 3px;
            font-size: 0.875rem;
            line-height: 1.6;
        }
        
        .callout-icon {
            font-size: 1.5rem;
            line-height: 1;
            flex-shrink: 0;
        }
        
        .callout-content {
            flex: 1;
        }
        
        .stats-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 1rem;
            margin: 1.5rem 0;
        }
        
        .stat-block {
            padding: 1rem;
            background: #ffffff;
            border: 1px solid #e9e7e3;
            border-radius: 3px;
        }
        
        .stat-label {
            font-size: 0.75rem;
            color: #787774;
            margin-bottom: 0.5rem;
            text-transform: uppercase;
            letter-spacing: 0.3px;
            font-weight: 500;
        }
        
        .stat-value {
            font-size: 2rem;
            font-weight: 600;
            color: #37352f;
            line-height: 1.2;
        }
        
        .stat-detail {
            font-size: 0.8125rem;
            color: #9b9a97;
            margin-top: 0.25rem;
        }
        
        h2 {
            font-weight: 600;
            color: #37352f;
            font-size: 1.5rem;
            margin-top: 2rem;
            margin-bottom: 0.75rem;
        }
        
        .table-wrapper {
            margin: 1.5rem 0;
            border: 1px solid #e9e7e3;
            border-radius: 3px;
            overflow: hidden;
        }
        
        table {
            width: 100%;
            border-collapse: collapse;
            font-size: 0.875rem;
        }
        
        thead {
            background: #f7f6f3;
        }
        
        th {
            text-align: left;
            padding: 0.5rem 0.75rem;
            font-weight: 500;
            color: #787774;
            font-size: 0.75rem;
            border-bottom: 1px solid #e9e7e3;
        }
        
        td {
            padding: 0.625rem 0.75rem;
            border-bottom: 1px solid #e9e7e3;
            color: #37352f;
        }
        
        tr:last-child td {
            border-bottom: none;
        }
        
        tbody tr:hover {
            background: #fafaf9;
        }
        
        .tag {
            display: inline-block;
            padding: 0.125rem 0.5rem;
            border-radius: 3px;
            font-size: 0.75rem;
            font-weight: 500;
        }
        
        .tag-blue { background: #e3f2fd; color: #1565c0; }
        .tag-green { background: #e8f5e9; color: #2e7d32; }
        .tag-orange { background: #fff3e0; color: #e65100; }
        .tag-purple { background: #f3e5f5; color: #6a1b9a; }
        .tag-red { background: #ffebee; color: #c62828; }
        .tag-gray { background: #f5f5f5; color: #616161; }
        
        .progress-row {
            margin: 1rem 0;
        }
        
        .progress-header {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            margin-bottom: 0.375rem;
            font-size: 0.875rem;
        }
        
        .progress-label {
            color: #37352f;
            font-weight: 500;
        }
        
        .progress-value {
            color: #787774;
            font-size: 0.8125rem;
        }
        
        .progress-bar {
            height: 6px;
            background: #e9e7e3;
            border-radius: 3px;
            overflow: hidden;
        }
        
        .progress-fill {
            height: 100%;
            background: #37352f;
            border-radius: 3px;
            transition: width 0.3s ease;
        }
        
        .progress-fill.warning { background: #fb8c00; }
        .progress-fill.success { background: #43a047; }
        
        .priority-card {
            border: 1px solid #e9e7e3;
            border-radius: 3px;
            padding: 1rem;
            margin: 0.75rem 0;
            background: #ffffff;
        }
        
        .priority-header {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            margin-bottom: 0.5rem;
        }
        
        .priority-title {
            font-weight: 600;
            font-size: 0.9375rem;
            color: #37352f;
        }
        
        .priority-description {
            font-size: 0.875rem;
            color: #787774;
            line-height: 1.6;
        }
        
        .priority-meta {
            display: flex;
            gap: 1.5rem;
            margin-top: 0.75rem;
            font-size: 0.8125rem;
            color: #9b9a97;
        }
        
        .priority-meta strong {
            color: #37352f;
            font-weight: 500;
        }
        
        .divider {
            height: 1px;
            background: #e9e7e3;
            margin: 2rem 0;
        }
        
        .flow-step {
            display: flex;
            align-items: flex-start;
            gap: 0.75rem;
            padding: 0.75rem;
            margin: 0.5rem 0;
            background: #fafaf9;
            border-radius: 3px;
            border-left: 2px solid #37352f;
        }
        
        .flow-number {
            font-weight: 600;
            color: #37352f;
            flex-shrink: 0;
        }
        
        .flow-content {
            flex: 1;
        }
        
        .flow-title {
            font-weight: 500;
            color: #37352f;
            margin-bottom: 0.125rem;
        }
        
        .flow-description {
            font-size: 0.8125rem;
            color: #787774;
        }
        
        .flow-arrow {
            text-align: center;
            color: #9b9a97;
            font-size: 1.25rem;
            margin: 0.25rem 0;
        }
        
        @media (max-width: 768px) {
            body { flex-direction: column; }
            .sidebar { 
                width: 100%; 
                height: auto; 
                border-right: none;
                border-bottom: 1px solid #e9e7e3;
            }
            .page-header { padding: 2rem 1.5rem 1.5rem 1.5rem; }
            .content-wrapper { padding: 1.5rem; }
            .stats-grid { grid-template-columns: 1fr; }
        }
    </style>
</head>
<body>
    <div class="sidebar">
        <div class="sidebar-header">
            <div class="workspace-name">
                <span>📊</span>
                <span>Integration Analysis</span>
            </div>
        </div>
        
        <div class="sidebar-section">
            <div class="section-title">Overview</div>
            <div class="nav-item active" data-section="overview">
                <span class="nav-icon">🏠</span>
                <span>Dashboard</span>
            </div>
        </div>
        
        <div class="sidebar-section">
            <div class="section-title">Integration Types</div>
            <div class="nav-item" data-section="managed-packages">
                <span class="nav-icon">📦</span>
                <span>Managed Packages</span>
            </div>
            <div class="nav-item" data-section="connected-apps">
                <span class="nav-icon">🔌</span>
                <span>Connected Apps</span>
            </div>
            <div class="nav-item" data-section="custom-code">
                <span class="nav-icon">💻</span>
                <span>Custom Code</span>
            </div>
        </div>
        
        <div class="sidebar-section">
            <div class="section-title">Analysis</div>
            <div class="nav-item" data-section="governance">
                <span class="nav-icon">⚖️</span>
                <span>Governance & Limits</span>
            </div>
            <div class="nav-item" data-section="data-flows">
                <span class="nav-icon">🔄</span>
                <span>Data Flows</span>
            </div>
            <div class="nav-item" data-section="recommendations">
                <span class="nav-icon">✅</span>
                <span>Action Plan</span>
            </div>
        </div>
    </div>
    
    <div class="main-content">
        <div class="page-header">
            <div class="page-icon">📊</div>
            <h1 class="page-title">Salesforce Integration Discovery</h1>
            <p class="page-subtitle">Comprehensive analysis of 52 integration points across managed packages, connected apps, and custom development</p>
        </div>
        
        <div class="content-wrapper">
            <div id="overview" class="content-section active">
                <div class="callout">
                    <span class="callout-icon">💡</span>
                    <div class="callout-content">
                        <strong>Key Finding:</strong> This environment demonstrates enterprise-grade integration maturity with 52 distinct integration points. Three resources approaching governor limits require monitoring: Apex classes (59%), Contact fields (52%), and daily API calls (45%).
                    </div>
                </div>
                
                <h2>Quick Statistics</h2>
                <div class="stats-grid">
                    <div class="stat-block">
                        <div class="stat-label">Total Integrations</div>
                        <div class="stat-value">52</div>
                        <div class="stat-detail">All integration types</div>
                    </div>
                    <div class="stat-block">
                        <div class="stat-label">Managed Packages</div>
                        <div class="stat-value">37</div>
                        <div class="stat-detail">AppExchange installations</div>
                    </div>
                    <div class="stat-block">
                        <div class="stat-label">Daily API Calls</div>
                        <div class="stat-value">45K</div>
                        <div class="stat-detail">45% of limit</div>
                    </div>
                    <div class="stat-block">
                        <div class="stat-label">Apex Classes</div>
                        <div class="stat-value">2,963</div>
                        <div class="stat-detail">59% of limit</div>
                    </div>
                    <div class="stat-block">
                        <div class="stat-label">Active Flows</div>
                        <div class="stat-value">23</div>
                        <div class="stat-detail">Automation</div>
                    </div>
                    <div class="stat-block">
                        <div class="stat-label">Integration Fields</div>
                        <div class="stat-value">217</div>
                        <div class="stat-detail">On Contact object</div>
                    </div>
                </div>
                
                <h2>Integration Distribution</h2>
                <div class="progress-row">
                    <div class="progress-header">
                        <span class="progress-label">Managed Packages</span>
                        <span class="progress-value">37 integrations</span>
                    </div>
                    <div class="progress-bar">
                        <div class="progress-fill" style="width: 71%;"></div>
                    </div>
                </div>
                <div class="progress-row">
                    <div class="progress-header">
                        <span class="progress-label">Custom Apex Classes</span>
                        <span class="progress-value">12 integrations</span>
                    </div>
                    <div class="progress-bar">
                        <div class="progress-fill" style="width: 23%;"></div>
                    </div>
                </div>
                <div class="progress-row">
                    <div class="progress-header">
                        <span class="progress-label">Connected Apps</span>
                        <span class="progress-value">8 integrations</span>
                    </div>
                    <div class="progress-bar">
                        <div class="progress-fill" style="width: 15%;"></div>
                    </div>
                </div>
            </div>
            
            <div id="managed-packages" class="content-section">
                <h2>Top Managed Packages by Complexity</h2>
                <div class="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>Platform</th>
                                <th>Namespace</th>
                                <th>Classes</th>
                                <th>Fields</th>
                                <th>Function</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>Conga Composer</strong></td>
                                <td><span class="tag tag-blue">APXTConga4</span></td>
                                <td>264</td>
                                <td>12</td>
                                <td>Document Generation</td>
                            </tr>
                            <tr>
                                <td><strong>DupeCatcher</strong></td>
                                <td><span class="tag tag-blue">SFSSDupeCatcher</span></td>
                                <td>247</td>
                                <td>8</td>
                                <td>Data Quality</td>
                            </tr>
                            <tr>
                                <td><strong>Zoom</strong></td>
                                <td><span class="tag tag-blue">ZVC</span></td>
                                <td>244</td>
                                <td>6</td>
                                <td>Communication</td>
                            </tr>
                            <tr>
                                <td><strong>DocuSign</strong></td>
                                <td><span class="tag tag-blue">dsfs</span></td>
                                <td>213</td>
                                <td>9</td>
                                <td>E-Signature</td>
                            </tr>
                            <tr>
                                <td><strong>Marketo</strong></td>
                                <td><span class="tag tag-blue">mkto_si</span></td>
                                <td>193</td>
                                <td>18</td>
                                <td>Marketing</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div id="connected-apps" class="content-section">
                <h2>Connected Apps</h2>
                <div class="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>App</th>
                                <th>Auth</th>
                                <th>Purpose</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>Slack</strong></td>
                                <td><span class="tag tag-green">OAuth 2.0</span></td>
                                <td>Team collaboration</td>
                            </tr>
                            <tr>
                                <td><strong>Google Workspace</strong></td>
                                <td><span class="tag tag-green">OAuth 2.0</span></td>
                                <td>Calendar sync</td>
                            </tr>
                            <tr>
                                <td><strong>Microsoft Teams</strong></td>
                                <td><span class="tag tag-green">OAuth 2.0</span></td>
                                <td>Meeting scheduling</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div id="custom-code" class="content-section">
                <h2>Custom Integration Classes</h2>
                <div class="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>Class</th>
                                <th>Type</th>
                                <th>LOC</th>
                                <th>Purpose</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>LeadEnrichmentBatch</strong></td>
                                <td><span class="tag tag-orange">Batch</span></td>
                                <td>234</td>
                                <td>Bulk enrichment</td>
                            </tr>
                            <tr>
                                <td><strong>BillingSystemIntegration</strong></td>
                                <td><span class="tag tag-orange">SOAP</span></td>
                                <td>213</td>
                                <td>Invoice sync</td>
                            </tr>
                            <tr>
                                <td><strong>QuoteGeneratorAPI</strong></td>
                                <td><span class="tag tag-orange">REST</span></td>
                                <td>167</td>
                                <td>Quote generation</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div id="governance" class="content-section">
                <h2>Governor Limits</h2>
                <div class="progress-row">
                    <div class="progress-header">
                        <span class="progress-label">Apex Classes</span>
                        <span class="progress-value">2,963 / 5,000</span>
                    </div>
                    <div class="progress-bar">
                        <div class="progress-fill warning" style="width: 59%;"></div>
                    </div>
                </div>
                <div class="progress-row">
                    <div class="progress-header">
                        <span class="progress-label">Contact Fields</span>
                        <span class="progress-value">418 / 800</span>
                    </div>
                    <div class="progress-bar">
                        <div class="progress-fill warning" style="width: 52%;"></div>
                    </div>
                </div>
                <div class="progress-row">
                    <div class="progress-header">
                        <span class="progress-label">Daily API Calls</span>
                        <span class="progress-value">45,000 / 100,000</span>
                    </div>
                    <div class="progress-bar">
                        <div class="progress-fill warning" style="width: 45%;"></div>
                    </div>
                </div>
            </div>
            
            <div id="data-flows" class="content-section">
                <h2>Lead Generation Flow</h2>
                <div class="flow-step">
                    <span class="flow-number">1</span>
                    <div class="flow-content">
                        <div class="flow-title">Lead Capture</div>
                        <div class="flow-description">New lead created from web form</div>
                    </div>
                </div>
                <div class="flow-arrow">↓</div>
                <div class="flow-step">
                    <span class="flow-number">2</span>
                    <div class="flow-content">
                        <div class="flow-title">Data Enrichment</div>
                        <div class="flow-description">ZoomInfo enriches 20+ fields</div>
                    </div>
                </div>
                <div class="flow-arrow">↓</div>
                <div class="flow-step">
                    <span class="flow-number">3</span>
                    <div class="flow-content">
                        <div class="flow-title">Sales Engagement</div>
                        <div class="flow-description">SalesLoft cadence enrollment</div>
                    </div>
                </div>
            </div>
            
            <div id="recommendations" class="content-section">
                <h2>High Priority Actions</h2>
                <div class="priority-card">
                    <div class="priority-header">
                        <span class="tag tag-red">High</span>
                        <div class="priority-title">Integration Monitoring Dashboard</div>
                    </div>
                    <div class="priority-description">
                        Implement centralized monitoring across all 52 integration points. No unified view of health, error rates, or performance metrics currently exists.
                    </div>
                    <div class="priority-meta">
                        <div><strong>Impact:</strong> Reduce MTTR by 60-80%</div>
                        <div><strong>Effort:</strong> 2-3 weeks</div>
                    </div>
                </div>
                
                <div class="priority-card">
                    <div class="priority-header">
                        <span class="tag tag-red">High</span>
                        <div class="priority-title">API Call Optimization</div>
                    </div>
                    <div class="priority-description">
                        Daily usage at 45,000 calls (45% of limit). Audit top consumers and implement caching before hitting 70% threshold.
                    </div>
                    <div class="priority-meta">
                        <div><strong>Impact:</strong> Prevent disruptions</div>
                        <div><strong>Effort:</strong> 1-2 weeks</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <script>
        document.querySelectorAll('.nav-item').forEach(item => {
            item.addEventListener('click', function() {
                const sectionId = this.getAttribute('data-section');
                
                // Hide all sections
                document.querySelectorAll('.content-section').forEach(section => {
                    section.classList.remove('active');
                });
                
                // Remove active from all nav items
                document.querySelectorAll('.nav-item').forEach(nav => {
                    nav.classList.remove('active');
                });
                
                // Show selected section
                document.getElementById(sectionId).classList.add('active');
                
                // Add active to clicked nav
                this.classList.add('active');
                
                // Scroll to top
                document.querySelector('.main-content').scrollTop = 0;
            });
        });
    </script>
</body>
</html>

`;
